export enum DocumentStatusEnum {
  INITIAL = 'initial',
  REGENERATE = 'regenerate',
  VERIFIED = 'verified',
}

export interface IQuestionnaireModel {
  mappingId: string | undefined;
  questionnaireId: string,
  questionnaireName: string,
  createAt: string,
  lastModifiedAt: string,
  categories: number,
  questions: number,
  documents: number,
}

export interface IDocumentModel {
  documentId: string,
  documentName?: string,
  createAt?: string,
  lastModifiedAt?: string,
  questionnaireName?: string,
  questionnaireId?: string,
  verifiedFields?: number;
  verifiedPercentage?: number;
  totalFields?: number;
  documentStatus?: DocumentStatusEnum,
}

export interface IMappingModel {
  mappingId: string,
  mappingName: string,
  createAt: string,
  lastModifiedAt: string,
  connections: number;
  questionnaireName: string,
}
